import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Philosophy from "@/pages/Philosophy";
import Principles from "@/pages/Principles";
import InvestmentThemes from "@/pages/InvestmentThemes";
import Portfolio from "@/pages/Portfolio";
import FamilyOffice from "@/pages/FamilyOffice";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/philosophy" element={<Philosophy />} />
            <Route path="/principles" element={<Principles />} />
            <Route path="/investments" element={<InvestmentThemes />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/family-office" element={<FamilyOffice />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
